
export function validateName(name) {
    const trimmedName = name.trim();

    if (!trimmedName) {
        return { valid: false, message: 'Name is required' };
    }

    if (trimmedName.length < 2 || trimmedName.length > 50) {
        return { valid: false, message: 'Name must be between 2 and 50 characters' };
    }

    const nameRegex = /^[A-Za-z\s'-]+$/;    // Allow only letters, spaces, hyphens, apostrophes
    if (!nameRegex.test(trimmedName)) {
        return { valid: false, message: 'Letters only, no numbers or symbols.' };
    }

    // Basic sanitization to block scripts (in case someone tries to be clever)
    if (/<[^>]*script/.test(trimmedName)) {
        return { valid: false, message: 'Invalid characters in name' };
    }

    return { valid: true, message: '' };
}

export function validatePassword(password) {
    const trimmedPassword = password.trim();

    if (!trimmedPassword) {
        return { valid: false, message: 'Password is required' }
    }

    if (trimmedPassword.length < 8) {
        return { valid: false, message: 'Password must be at least 6 characters' }
    }

    let strength = 0;
    if (trimmedPassword.length >= 8) strength++;
    if (/[A-Z]/.test(trimmedPassword)) strength++;
    if (/[a-z]/.test(trimmedPassword)) strength++;
    if (/^[A-Za-z][A-Za-z0-9!@#$%^&*]*$/.test(trimmedPassword)) strength++;

    let strengthMessage = '';
    let isValid = false

    switch (strength) {
        case 0:
        case 1:
            strengthMessage = 'Too Weak';
            break;
        case 2:
            strengthMessage = 'Fair';
            isValid = true;
            break;
        case 3:
            strengthMessage = 'Good';
            isValid = true;
            break;
        case 4:
            strengthMessage = 'Excellent';
            isValid = true;
            break;
        default:
            strengthMessage = '';
    }

    return {
        valid: isValid,
        strengthMessage: strengthMessage,
        message: '',
    };
}

export function validateEmail(email) {
    const trimmedEmail = email.trim();

    if (!trimmedEmail) {
        return { valid: false, message: 'Email is required' };
    }

    const basicEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!basicEmailRegex.test(trimmedEmail)) {
        return { valid: false, message: 'Invalid email format' };
    }

    const [localPart, domain] = trimmedEmail.split('@');

    // Reject local or domain part if it’s just one repeating character (like aaaaaa or bbb)
    const isRepeating = (str) => /^([a-zA-Z0-9])\1{4,}$/.test(str); // 5+ repeating chars
    if (isRepeating(localPart) || isRepeating(domain.split('.')[0])) {
        return { valid: false, message: 'Too many repeating characters' };
    }

    return { valid: true, message: '' };
}

export function validateCompanyName(company_name) { 
    const trimmed = company_name.trim();
    if (!trimmed) {
        return { valid: false, message: 'Company name is required' };
    }
    if (trimmed.length < 2 || trimmed.length > 100) {
        return { valid: false, message: 'Company name must be between 2 and 100 characters' };
    }
    if (/<[^>]*script/.test(trimmed)) {
        return { valid: false, message: 'Invalid characters in company name' };
    }
    return { valid: true, message: '' };
}

export function validateContact(contact) {
    const trimmed = contact.trim();
    if (!trimmed) {
        return { valid: false, message: 'Contact number is required' };
    }
    const phoneRegex = /^[0-9]{7,15}$/;
    if (!phoneRegex.test(trimmed)) {
        return { valid: false, message: 'Invalid contact number (7–15 digits)' };
    }
    return { valid: true, message: '' };
}

export function validateCompanyURL(company_url) {
    const trimmed = company_url.trim();
    if (!trimmed) {
        return { valid: false, message: 'Company URL is required' };
    }
    try {
        const parsedUrl = new URL(trimmed.startsWith('http') ? trimmed : `https://${trimmed}`);
        if (!parsedUrl.hostname.includes('.')) {
            return { valid: false, message: 'Invalid URL format' };
        }
        return { valid: true, message: '' };
    } catch {
        return { valid: false, message: 'Invalid URL' };
    }
}

export function validateCountry(country) {
    const trimmed = country.trim();
    if (!trimmed) {
        return { valid: false, message: 'Country is required' };
    }
    const countryRegex = /^[A-Za-z\\s'-]{2,50}$/;
    if (!countryRegex.test(trimmed)) {
        return { valid: false, message: 'Invalid country name' };
    }
    return { valid: true, message: '' };
}
